// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"84":"6e1da653","97":"590dfa98","388":"f5a90ccb","725":"6c1345c4"}[chunkId] + ".js";
};